import React, { useEffect, useState } from "react";
import { get } from "util/requests";

import "chartjs-adapter-luxon";

import styles from "./line_chart.module.css";
import LineChartSelector from "ui/general/line_chart_selector";

import Chart from "./components/chart";

export default function LineChart(props) {
  const { sitesRegions, params, setSearchParams } = props;
  const [data, setData] = useState(null);

  useEffect(() => {
    let label = "All Sites";

    get("/enrollment_over_time", { params: { ...params } }).then((ret) => {
      let data = ret.data.graph_data;
      if (params?.filter === "site" && params?.site) {
        label = sitesRegions?.sites.find((s) => parseInt(s.id) === parseInt(params.site))?.name;
      }
      if (params?.filter === "region" && params?.region) {
        label = sitesRegions?.regions.find((r) => parseInt(r.id) === parseInt(params.region))?.name;
      }

      data.datasets[0].label = label;
      setData(data);

      // const ctx = chartRef.current.getContext("2d");
      // if (myChart) {
      //   myChart.destroy();
      // }
      // try {
      //   myChart = new Chart(ctx, {
      //     type: "line",
      //     data: data,
      //     options: {
      //       responsive: true,
      //       maintainAspectRatio: false,
      //       plugins: {
      //         title: {
      //           display: false,
      //           // text: "Enrollment over Time",
      //         },
      //       },
      //       interaction: {
      //         intersect: false,
      //       },
      //       scales: {
      //         x: {
      //           display: true,
      //           title: {
      //             display: true,
      //           },
      //           type: "time",
      //           time: {
      //             // Luxon format string
      //             tooltipFormat: "mm DD",
      //           },
      //         },
      //         y: {
      //           display: true,
      //           title: {
      //             display: true,
      //             text: "Subjects Enrolled",
      //           },
      //           // suggestedMin: -10,
      //           // suggestedMax: 200,
      //         },
      //       },
      //     },
      //   });
      // } catch (err) {
      //   console.log("err", err);
      // }
    });

    // return () => {
    //   // cancelToken.cancel();
    //   if (myChart) {
    //     myChart.destroy();
    //   }
    // };
  }, [sitesRegions, params.site, params.region, params.time, params.filter]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.chart_wrapper}>
        <Chart data={data} />
      </div>
      <div className={styles.selector_wrapper}>
        <LineChartSelector mode={params.time} onClick={(time) => setSearchParams({ ...params, time })} />
      </div>
    </div>
  );
}
